import { createSlice } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux'
import { cleanReducerOnPageChange, ANY_VALUE } from '../utils'
import settings from '../conf'

export const STORAGE_KEY = `forwalk-favorites-site-${settings.SITE_ID}`

export const getFavorites = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []
  } catch (error) {
    return []
  }
}

export const setFavorites = (favorites) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(favorites));
}

export const getInitialState = (state) => {
  state = state || {
    padding: null,
    favorites: getFavorites(),
  };
  return state;
}

const initialState = getInitialState()

const mapSlice = createSlice({
  name: 'map',
  initialState,
  reducers: {
    setMapExtent(state, action){
      state.extent = { 
        bounds: action.payload.bounds,
        bestFitBaering: action.payload.bestFitBaering || false,
        timeStamp : new Date().getTime()
      }
    }
    ,setMapView(state, action){
      state.position = {
        lnglat: action.payload.lnglat,
        bearing: action.payload.bearing,
        zoom: action.payload.zoom,
        timeStamp: new Date().getTime()
      }
    }
    ,setMapPadding(state, action){
      state.padding = Object.assign({}, state.mapPadding, action.payload)
    }
    ,setMapHighlightTrail(state, action){
      state.highlightTrailId = action.payload;
    }
    ,setMapPin(state, action){
      state.pin = action.payload;
    }
    ,setPermentMapPin(state, action){
      state.premamentpin = action.payload;
    }
    ,addMapFeatures(state, action){
      if (!state.features){
        state.features = action.payload 
      } else {
        state.features.push(...action.payload) 
      }
    }
    ,removeMapFeatures(state, action){
      if (!state.features) return;
      const ids = action.payload.map((x)=>x.id)
      for ([idx, feature] of Object.entries(state.features)){
        if (ids.indexOf(feature.id) != -1){
            state.features.splice(idx, 1)
        }
      }
    }
    ,addMapFavorite(state, action){
      state.favorites.push(action.payload)
      setFavorites(state.favorites)
    }
    ,removeMapFavorite(state, action){
      for ([idx, feature] of Object.entries(state.favorites)){
        if (feature.id == action.payload.id && feature.type == action.payload.type){
            state.favorites.splice(idx, 1)
        }
      }
      setFavorites(state.favorites)
    }
  },
  extraReducers: (builder) => cleanReducerOnPageChange(builder, getInitialState)
})

export const 
  useMapExtent = () => useSelector(state => state.map.extent),
  useMapView = () => useSelector(state => state.map.position),
  useMapPadding = () => useSelector(state => state.map.padding),
  useMapHighlightTrailId = () => useSelector(state => state.map.highlightTrailId),
  useMapPin = () => useSelector(state => state.map.pin || state.map.premamentpin),
  useHasMapFeatures = () => useSelector(state => state.map.features && state.map.features.length > 0),
  useMapFeatures = () => useSelector(state => state.map.features),
  useMapFavorites = () => useSelector(state => state.map.favorites),
  useMapIsFavorite = (favorite) => useSelector(state => state.map.favorites && state.map.favorites.some((x) => x.id==favorite.id && x.type==favorite.type))

export const { 
  setMapExtent,
  setMapView,
  setMapPadding,
  setMapHighlightTrail,
  setMapPin,
  setPermentMapPin,
  addMapFeatures,
  removeMapFeatures,
  addMapFavorite,
  removeMapFavorite
} = mapSlice.actions

export default mapSlice
